import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { FaSpinner } from 'react-icons/fa';
import { ImNewTab } from 'react-icons/im';
import { RxCrossCircled } from 'react-icons/rx';
import { IoIosCheckmarkCircleOutline } from 'react-icons/io';
import toast from 'react-hot-toast';
import { ColoredCheckSquareIcon } from 'ui-component/custom-icons/icons';
import { Skeleton, Tooltip } from '@mui/material';

// ✅ Clear
const DetailModal = ({ isOpen, onClose, selectedId, isApproved, onRemove, onApprove }) => {
	const [data, setData] = useState([]);
	const [isLoading, setIsLoading] = useState(true);
	const [isButtonsDisabled, setIsButtonsDisabled] = useState('');

	useEffect(() => {
		api.getClientGeneralInformation(selectedId).then((res) => {
			setData(res.data);
			setIsLoading(false);
			res.data.client === null ||
			// res.data.companyBank === null ||
			res.data.companyBillingAddress === null ||
			res.data.companyContact === null ||
			res.data.companyDoc === null ||
			res.data.companyInfo === null ||
			res.data.companyShippingAddress === null
		});
	}, [selectedId]);

	const companyActivity = data?.dropdowns?.find((dropdown) => dropdown.type === 'Company Activity')?.name;
	const companyTurnover = data?.dropdowns?.find((dropdown) => dropdown.type === 'Company Turnover')?.name;

	const approveContact = (id) => {
		setIsButtonsDisabled('APPROVE')
		api
			.approveClients(id)
			.then((res) => {
				setIsButtonsDisabled('')
				toast.success('Contact Approved Successfully');
				onClose();
				// onRemove(id)
				onApprove(id)
			})
			.catch((err) => {
				console.log(err);
				toast.error('Failed to Approve Contact');
			});
	};

	const rejectContact = (id) => {
		setIsButtonsDisabled('REJECT')
		api
			.rejectClients(id)
			.then((res) => {
				setIsButtonsDisabled('')
				toast.success('Contact Rejected Successfully');
				onClose();
				onRemove(id)
			})
			.catch((err) => {
				console.log(err);
				toast.error('Failed to Reject Contact');
			});
	};
	
	return (
		<Modal show={'true'} onHide={onClose} centered size="lg">
			<Modal.Body>
				<div className="">
					<div className="mb-2 ml-0 pl-0">
						<div className="row" style={{ marginBottom: 20 }}>
							<div className="col-12">
								<h4 style={{ marginBottom: 0, fontWeight: 600, padding: '10px 10px 0 10px' }}>Client Details</h4>
								<button className="btn modal-close-icon" style={{ top: '-5px' }} onClick={onClose}>
									<svg
										id="Component_127_1"
										height="16"
										width="16"
										data-name="Component 127 – 1"
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 19.295 19.289"
									>
										<path
											id="Icon_ionic-ios-close"
											data-name="Icon ionic-ios-close"
											d="M23.219,20.933l6.891-6.891a1.615,1.615,0,0,0-2.284-2.284L20.935,18.65l-6.891-6.891a1.615,1.615,0,1,0-2.284,2.284l6.891,6.891L11.76,27.825a1.615,1.615,0,1,0,2.284,2.284l6.891-6.891,6.891,6.891a1.615,1.615,0,1,0,2.284-2.284Z"
											transform="translate(-11.285 -11.289)"
										/>
									</svg>
								</button>
							</div>
						</div>
						<div
							style={{
								maxHeight: '70vh',
								overflowY: 'auto',
								padding: '0 10px',
								scrollbarWidth: 'thin',
								scrollbarColor: 'transparent transparent'
							}}
						>

								<div className="row" style={{ marginBottom: 20 }}>
									<div className="col-12" style={{ marginBottom: 20 }}>
										<h5 style={{ marginBottom: 0, fontWeight: 600 }}>Company Info</h5>
									</div>
									<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
										{
											isLoading ? (
												<div className="w-full">
													<div style={{ width: '150px', marginBottom: '12px' }}>
														<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '12px' }} />
													</div>
													<div>
														<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
													</div>
												</div>
											) : (
												<>
													<label style={{ color: '#595959' }} className="fw-500">First Name</label>
													<input type="text" className="form-control" value={data?.client?.first_name} disabled />
												</>
											)
										}
									</div>
									<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
										{
											isLoading ? (
												<>
													<div className="w-full">
														<div style={{ width: '150px', marginBottom: '12px' }}>
															<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '12px' }} />
														</div>
														<div>
															<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
														</div>
													</div>
												</>
											) : (
												<>
													<label style={{ color: '#595959' }} className="fw-500">Last Name</label>
													<input type="text" className="form-control" value={data?.client?.last_name} disabled />
												</>
											)
										}
									</div>
									<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
										{
											isLoading ? (
												<div className="w-full">
													<div style={{ width: '150px', marginBottom: '12px' }}>
														<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '12px' }} />
													</div>
													<div>
														<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
													</div>
												</div>
											) : (
												<>
													<label style={{ color: '#595959' }} className="fw-500">Phone Number</label>
													<input type="text" className="form-control" value={data?.client?.number} disabled />
												</>
											)
										}
									</div>
									<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
										{
											isLoading ? (
												<div className="w-full">
													<div style={{ width: '150px', marginBottom: '12px' }}>
														<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '12px' }} />
													</div>
													<div>
														<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
													</div>
												</div>
											) : (
												<>
													<label style={{ color: '#595959' }} className="fw-500">Email Address</label>
													<input type="text" className="form-control" value={data?.client?.email} disabled />
												</>
											)
										}
									</div>
									<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
										{
											isLoading ? (
												<div className="w-full">
													<div style={{ width: '150px', marginBottom: '12px' }}>
														<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '12px' }} />
													</div>
													<div>
														<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
													</div>
												</div>
											) : (
												<>
													<label style={{ color: '#595959' }} className="fw-500">Company Name</label>
													<input type="text" className="form-control" value={data?.client?.company_name} disabled />
												</>
											)
										}
									</div>
									<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
										{
											isLoading ? (
												<div className="w-full">
													<div style={{ width: '150px', marginBottom: '12px' }}>
														<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '12px' }} />
													</div>
													<div>
														<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
													</div>
												</div>
											) : (
												<>
													<label style={{ color: '#595959' }} className="fw-500">Establishment Year</label>
													{
														data?.companyInfo?.establishment_year ? (
															<input type="text" className="form-control" value={data?.companyInfo?.establishment_year} disabled />
														) : (
															<input type="text" className="form-control" value={'--- N/A ---'} style={{ color: '#707070' }} disabled />
														)
													}
												</>
											)
										}
									</div>
									<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
										{
											isLoading ? (
												<div className="w-full">
													<div style={{ width: '150px', marginBottom: '12px' }}>
														<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '12px' }} />
													</div>
													<div>
														<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
													</div>
												</div>
											) : (
												<>
													<label style={{ color: '#595959' }} className="fw-500">Activities</label>
													{
														companyActivity ? (
															<input type="text" className="form-control" value={companyActivity} disabled />
														) : (
															<input type="text" className="form-control" value={'--- N/A ---'} style={{ color: '#707070' }} disabled />
														)
													}
												</>
											)
										}
									</div>
									<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
										{
											isLoading ? (
												<div className="w-full">
													<div style={{ width: '150px', marginBottom: '12px' }}>
														<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '12px' }} />
													</div>
													<div>
														<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
													</div>
												</div>
											) : (
												<>
													<label style={{ color: '#595959' }} className="fw-500">Annual Turnover</label>
													{
														companyTurnover ? (
															<input type="text" className="form-control" value={companyTurnover} disabled />
														) : (
															<input type="text" className="form-control" value={'--- N/A ---'} style={{ color: '#707070' }} disabled />
														)
													}
												</>
											)
										}
									</div>
								</div>
								<div className="row" style={{ marginBottom: 20 }}>
									<div className="col-12" style={{ marginBottom: 20 }}>
										<h5 style={{ marginBottom: 0, fontWeight: 600 }}>Contacts</h5>
									</div>
									{
										isLoading ? (
											<>
												<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
													<div className="w-full">
														<div style={{ width: '150px', marginBottom: '12px' }}>
															<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '12px' }} />
														</div>
														<div>
															<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
														</div>
													</div>
												</div>
												<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
													<div className="w-full">
														<div style={{ width: '150px', marginBottom: '12px' }}>
															<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '12px' }} />
														</div>
														<div>
															<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
														</div>
													</div>
												</div>
												<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
													<div className="w-full">
														<div style={{ width: '150px', marginBottom: '12px' }}>
															<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '12px' }} />
														</div>
														<div>
															<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
														</div>
													</div>
												</div>
												<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
													<div className="w-full">
														<div style={{ width: '150px', marginBottom: '12px' }}>
															<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '12px' }} />
														</div>
														<div>
															<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
														</div>
													</div>
													
												</div>
												<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
													<div className="w-full">
														<div style={{ width: '150px', marginBottom: '12px' }}>
															<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '12px' }} />
														</div>
														<div>
															<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
														</div>
													</div>
													
												</div>

											</>
										) : (
											(data?.companyContact?.contact_person || data?.companyContact?.email || data?.companyContact?.website || data?.companyContact?.phone_number || data?.companyContact?.whatsapp) ? (
												<>
													<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
														<label style={{ color: '#595959' }} className="fw-500">Sales Contact</label>
														{
															data?.companyContact?.contact_person ? (
																<input type="text" className="form-control" value={data?.companyContact?.contact_person} disabled />
															) : (
																<input type="text" className="form-control" value={'--- N/A ---'} style={{ color: '#707070' }} disabled />
															)
														}
													</div>
													<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
														<label style={{ color: '#595959' }} className="fw-500">Company Email</label>
														{
															data?.companyContact?.email ? (
																<input type="text" className="form-control" value={data?.companyContact?.email} disabled />
															) : (
																<input type="text" className="form-control" value={'--- N/A ---'} style={{ color: '#707070' }} disabled />
															)
														}
													</div>
													<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
														<label style={{ color: '#595959' }} className="fw-500">Website</label>
														{
															data?.companyContact?.website ? (
																<input type="text" className="form-control" value={data?.companyContact?.website} disabled></input>
															) : (
																<input type="text" className="form-control" value={'--- N/A ---'} style={{ color: '#707070' }} disabled />
															)
														}
													</div>
													<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
														<label style={{ color: '#595959' }} className="fw-500">Phone Number</label>
														{
															data?.companyContact?.phone_number ? (
																<input type="text" className="form-control" value={`${data?.companyContact?.phone_code}${data?.companyContact?.phone_number}`} disabled />
															) : (
																<input type="text" className="form-control" value={'--- N/A ---'} style={{ color: '#707070' }} disabled />
															)
														}
														
													</div>
													<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
														<label style={{ color: '#595959' }} className="fw-500">WhatsApp Number</label>
														{
															data?.companyContact?.whatsapp ? (
																<input type="text" className="form-control" value={`${data?.companyContact?.whatsapp_code}${data?.companyContact?.whatsapp}`} disabled />
															) : (
																<input type="text" className="form-control" value={'--- N/A ---'} style={{ color: '#707070' }} disabled />
															)
														}
														
													</div>
												</>
											) : (
												<div className="col-12 mb-3 contacts-approval-no-data">
													No information available
												</div>
											)
										)
									}
								</div>
								<div className="row" style={{ marginBottom: 20 }}>
									<div className="col-12" style={{ marginBottom: 20 }}>
										<h5 style={{ marginBottom: 0, fontWeight: 600 }}>Billing Address</h5>
									</div>
									{
										isLoading ? (
											<>
												<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
													<div className="w-full">
														<div style={{ width: '150px', marginBottom: '12px' }}>
															<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '12px' }} />
														</div>
														<div>
															<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
														</div>
													</div>
												</div>
												<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
													<div className="w-full">
														<div style={{ width: '150px', marginBottom: '12px' }}>
															<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '12px' }} />
														</div>
														<div>
															<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
														</div>
													</div>
												</div>
												<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
													<div className="w-full">
														<div style={{ width: '150px', marginBottom: '12px' }}>
															<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '12px' }} />
														</div>
														<div>
															<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
														</div>
													</div>
												</div>
												<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
													<div className="w-full">
														<div style={{ width: '150px', marginBottom: '12px' }}>
															<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '12px' }} />
														</div>
														<div>
															<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
														</div>
													</div>
												</div>

											</>
										) : (
											(data?.companyBillingAddress?.address || data?.companyBillingAddress?.city || data?.companyBillingAddress?.zip || data?.companyBillingAddress?.country) ? (	
												<>
													<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
														<label style={{ color: '#595959' }} className="fw-500">Address</label>
														{
															data?.companyBillingAddress?.address ? (
																<input type="text" className="form-control" value={data?.companyBillingAddress?.address} disabled />
															) : (
																<input type="text" className="form-control" value={'--- N/A ---'} style={{ color: '#707070' }} disabled />
															)
														}
													</div>
													<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
														<label style={{ color: '#595959' }} className="fw-500">City</label>
														{
															data?.companyBillingAddress?.city ? (
																<input type="text" className="form-control" value={data?.companyBillingAddress?.city} disabled />
															) : (
																<input type="text" className="form-control" value={'--- N/A ---'} style={{ color: '#707070' }} disabled />
															)
														}
													</div>
													<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
														<label style={{ color: '#595959' }} className="fw-500">Zip Code</label>
														{
															data?.companyBillingAddress?.zip ? (
																<input type="text" className="form-control" value={data?.companyBillingAddress?.zip} disabled />
															) : (
																<input type="text" className="form-control" value={'--- N/A ---'} style={{ color: '#707070' }} disabled />
															)
														}
													</div>
													<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
														<label style={{ color: '#595959' }} className="fw-500">Country</label>
														{
															data?.companyBillingAddress?.country ? (
																<input type="text" className="form-control" value={data?.companyBillingAddress?.country} disabled />
															) : (
																<input type="text" className="form-control" value={'--- N/A ---'} style={{ color: '#707070' }} disabled />
															)
														}
													</div>
												</>
											) : (
												<div className="col-12 mb-3 contacts-approval-no-data">
													No available billing address
												</div>
											)
										)
									}
								</div>
								<div className="row" style={{ marginBottom: 20 }}>
									<div className="col-12" style={{ marginBottom: 20 }}>
										<h5 style={{ marginBottom: 0, fontWeight: 600 }}>Shipping Address</h5>
									</div>
									{
										isLoading ? (
											<>

												<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
													<div className="w-full">
														<div style={{ width: '150px', marginBottom: '12px' }}>
															<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '12px' }} />
														</div>
														<div>
															<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
														</div>
													</div>
												</div>
												<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
													<div className="w-full">
														<div style={{ width: '150px', marginBottom: '12px' }}>
															<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '12px' }} />
														</div>
														<div>
															<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
														</div>
													</div>
												</div>
												<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
													<div className="w-full">
														<div style={{ width: '150px', marginBottom: '12px' }}>
															<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '12px' }} />
														</div>
														<div>
															<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
														</div>
													</div>
												</div>
												<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
													<div className="w-full">
														<div style={{ width: '150px', marginBottom: '12px' }}>
															<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '12px' }} />
														</div>
														<div>
															<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
														</div>
													</div>
												</div>

											</>
										) : (
											(data?.companyShippingAddress?.address || data?.companyShippingAddress?.city || data?.companyShippingAddress?.zip || data?.companyShippingAddress?.country) ? (
												<>
													<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
														<label style={{ color: '#595959' }} className="fw-500">Address</label>
														{
															data?.companyShippingAddress?.address ? (
																<input type="text" className="form-control" value={data?.companyShippingAddress?.address} disabled />
															) : (
																<input type="text" className="form-control" value={'--- N/A ---'} style={{ color: '#707070' }} disabled />
															)
														}
													</div>
													<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
														<label style={{ color: '#595959' }} className="fw-500">City</label>
														{
															data?.companyShippingAddress?.city ? (
																<input type="text" className="form-control" value={data?.companyShippingAddress?.city} disabled />
															) : (
																<input type="text" className="form-control" value={'--- N/A ---'} style={{ color: '#707070' }} disabled />
															)
														}
													</div>
													<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
														<label style={{ color: '#595959' }} className="fw-500">Zip Code</label>
														{
															data?.companyShippingAddress?.zip ? (
																<input type="text" className="form-control" value={data?.companyShippingAddress?.zip} disabled />
															) : (
																<input type="text" className="form-control" value={'--- N/A ---'} style={{ color: '#707070' }} disabled />
															)
														}
													</div>
													<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
														<label style={{ color: '#595959' }} className="fw-500">Country</label>
														{
															data?.companyShippingAddress?.country ? (
																<input type="text" className="form-control" value={data?.companyShippingAddress?.country} disabled />
															) : (
																<input type="text" className="form-control" value={'--- N/A ---'} style={{ color: '#707070' }} disabled />
															)
														}
													</div>
												</>
											) : (
												<div className="col-12 mb-3 contacts-approval-no-data">
													No available shipping address
												</div>
											)
										)
									}
								</div>
								<div className="row" style={{ marginBottom: 20 }}>
									<div className="col-12" style={{ marginBottom: 20 }}>
										<h5 style={{ marginBottom: 0, fontWeight: 600 }}>Documents</h5>
									</div>
									{
										isLoading ? (
											<>
												<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
													<div className="w-full">
														<div style={{ width: '150px', marginBottom: '12px' }}>
															<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '12px' }} />
														</div>
														<div>
															<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
														</div>
													</div>
												</div>
												<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
													<div className="w-full">
														<div style={{ width: '150px', marginBottom: '12px' }}>
															<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '12px' }} />
														</div>
														<div>
															<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
														</div>
													</div>
												</div>
											</>
										) : (
											(data?.companyDoc?.vat_code || data?.companyDoc?.registration_number) ? (
												<>
													<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
														<label style={{ color: '#595959' }} className="fw-500">
															<div className="flex align-items-center gap-2">
																<div>
																	VAT code
																</div>
																{
																	data?.companyDoc?.is_vat_applicable === 'Not Applicable' && (
																		<a href="javascript:void(0)" className="text-decoration-none">
																			<Tooltip title="Not Applicable" arrow placement="top">
																				<span className="">
																					<ColoredCheckSquareIcon height='15px' width='15px' />	
																				</span>
																			</Tooltip>
																		</a>
																	)
																}
															</div>
															
														</label>
														{
															data?.companyDoc?.vat_code ? (
																<input type="text" className="form-control" value={data?.companyDoc?.vat_code} disabled></input>
															) : (
																<input type="text" className="form-control" value={'--- N/A ---'} style={{ color: '#707070' }} disabled />
															)
														}
													</div>
													<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
														<label style={{ color: '#595959' }} className="fw-500">Registration Number</label>
														{
															data?.companyDoc?.registration_number ? (
																<input type="text" className="form-control" value={data?.companyDoc?.registration_number} disabled></input>
															) : (
																<input type="text" className="form-control" value={'--- N/A ---'} style={{ color: '#707070' }} disabled />
															)
														}
													</div>
												</>
											) : (
												<div className="col-12 mb-3 contacts-approval-no-data">
													No available documents
												</div>
											)
										)
									}
									<div className="col-12" style={{ marginBottom: 20, marginTop: 20 }}>
										<h5 style={{ marginBottom: 0, fontWeight: 600 }}>Attachment</h5>
									</div>
									
									{
										isLoading ? (
											<>
												<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
													<div className="w-full">
														<div style={{ width: '150px', marginBottom: '12px' }}>
															<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '12px' }} />
														</div>
														<div>
															<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
														</div>
													</div>
												</div>
												<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
													<div className="w-full">
														<div style={{ width: '150px', marginBottom: '12px' }}>
															<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '12px' }} />
														</div>
														<div>
															<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
														</div>
													</div>
												</div>
												<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
													<div className="w-full">
														<div style={{ width: '150px', marginBottom: '12px' }}>
															<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '12px' }} />
														</div>
														<div>
															<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
														</div>
													</div>
												</div>
											</>
										) : (
											(data?.companyDoc?.vat_doc_url || data?.companyDoc?.registration_doc_url || data?.companyDoc?.company_logo_url) ? (
												<>
													<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
																	
														<label style={{ color: '#595959' }} className="fw-500">
															
															<div className="flex align-items-center gap-2">
																<div>
																	VAT File
																</div>
																{
																	data?.companyDoc?.is_vat_applicable === 'Not Applicable' && (
																		<a href="javascript:void(0)" className="text-decoration-none">
																			<Tooltip title="Not Applicable" arrow placement="top">
																				<span className="">
																					<ColoredCheckSquareIcon height='15px' width='15px' />	
																				</span>
																			</Tooltip>
																		</a>
																	)
																}
															</div>
														</label>
														{
															data?.companyDoc?.vat_doc_url ? (
																<a
																	href={data?.companyDoc?.vat_doc_url || '#'}
																	target={data?.companyDoc?.vat_doc_url ? '_blank' : '_self'}
																	rel="noopener noreferrer"
																	style={{ color: 'inherit', textDecoration: 'none' }}
																>
																	<div className="attachments-file-client">
																		{`${data?.companyDoc?.vat_doc.split('/').pop().substring(0, 25)}`}
																		<ImNewTab size={20} />
																	</div>
																</a>
															) : (
																<input type="text" className="form-control" value={'--- N/A ---'} style={{ color: '#707070' }} disabled />
															)
														}
													</div>
													<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
														<label style={{ color: '#595959' }} className="fw-500">Registration File</label>
														{
															data?.companyDoc?.registration_doc_url ? (
																<a
																	href={data?.companyDoc?.registration_doc_url || '#'}
																	target={data?.companyDoc?.registration_doc_url ? '_blank' : '_self'}
																	rel="noopener noreferrer"
																	style={{ color: 'inherit', textDecoration: 'none' }}
																>
																	<div className="attachments-file-client">
																		{`${data?.companyDoc?.registration_doc.split('/').pop().substring(0, 25)}`}
																		<ImNewTab size={20} />
																	</div>
																</a>
															) : (
																<input type="text" className="form-control" value={'--- N/A ---'} style={{ color: '#707070' }} disabled />
															)
														}
													</div>
													<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
														<label style={{ color: '#595959' }} className="fw-500">Company Logo</label>
														{
															data?.companyDoc?.company_logo_url ? (
																<a
																	href={data?.companyDoc?.company_logo_url || '#'}
																	target={data?.companyDoc?.company_logo_url ? '_blank' : '_self'}
																	rel="noopener noreferrer"
																	style={{ color: 'inherit', textDecoration: 'none' }}
																>
																	<div className="attachments-file-client">
																		{`${data?.companyDoc?.company_logo.split('/').pop().substring(0, 25)}`}
																		<ImNewTab size={20} />
																	</div>
																</a>
															) : (
																<input type="text" className="form-control" value={'--- N/A ---'} style={{ color: '#707070' }} disabled />
															)
														}
													</div>
												</>
											) : (
												<div className="col-12 mb-3 contacts-approval-no-data">
													No available attachment
												</div>
											)
										)
									}
								</div>
								<div className="row" style={{ marginBottom: 20 }}>
									<div className="col-12" style={{ marginBottom: 20 }}>
										<h5 style={{ marginBottom: 0, fontWeight: 600 }}>Bank Details</h5>
									</div>
									{
										isLoading ? (
											<>
												
												<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
													<div className="w-full">
														<div style={{ width: '150px', marginBottom: '12px' }}>
															<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '12px' }} />
														</div>
														<div>
															<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
														</div>
													</div>
												</div>
												<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
													<div className="w-full">
														<div style={{ width: '150px', marginBottom: '12px' }}>
															<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '12px' }} />
														</div>
														<div>
															<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
														</div>
													</div>
												</div>
												<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
													<div className="w-full">
														<div style={{ width: '150px', marginBottom: '12px' }}>
															<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '12px' }} />
														</div>
														<div>
															<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
														</div>
													</div>
												</div>
												<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
													<div className="w-full">
														<div style={{ width: '150px', marginBottom: '12px' }}>
															<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '12px' }} />
														</div>
														<div>
															<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
														</div>
													</div>
												</div>
												<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
													<div className="w-full">
														<div style={{ width: '150px', marginBottom: '12px' }}>
															<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '12px' }} />
														</div>
														<div>
															<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
														</div>
													</div>
												</div>
											</>
										) : (
											<>
												{
													(data?.companyBank?.bank_name || data?.companyBank?.bank_beneficiary_name || data?.companyBank?.bank_IBAN || data?.companyBank?.bank_SWIFT || data?.companyBank?.bank_address) ? (
														<>
															<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
																<label style={{ color: '#595959' }} className="fw-500">Bank Name</label>
																{
																	data?.companyBank?.bank_name ? (
																		<input type="text" className="form-control" value={data?.companyBank?.bank_name} disabled />
																	) : (
																		<input type="text" className="form-control" value={'--- N/A ---'} style={{ color: '#707070' }} disabled />
																	)
																}
															</div>
															<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
																<label style={{ color: '#595959' }} className="fw-500">Bank Beneficiary</label>
																{
																	data?.companyBank?.bank_beneficiary_name ? (
																		<input type="text" className="form-control" value={data?.companyBank?.bank_beneficiary_name} disabled />
																	) : (
																		<input type="text" className="form-control" value={'--- N/A ---'} style={{ color: '#707070' }} disabled />
																	)
																}
															</div>
															<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
																<label style={{ color: '#595959' }} className="fw-500">Bank IBAN</label>
																{
																	data?.companyBank?.bank_IBAN ? (
																		<input type="text" className="form-control" value={data?.companyBank?.bank_IBAN} disabled />
																	) : (
																		<input type="text" className="form-control" value={'--- N/A ---'} style={{ color: '#707070' }} disabled />
																	)
																}
															</div>
															<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
																<label style={{ color: '#595959' }} className="fw-500">Bank SWIFT</label>
																{
																	data?.companyBank?.bank_SWIFT ? (
																		<input type="text" className="form-control" value={data?.companyBank?.bank_SWIFT} disabled />
																	) : (
																		<input type="text" className="form-control" value={'--- N/A ---'} style={{ color: '#707070' }} disabled />
																	)
																}
															</div>
															<div className="col-lg-4 col-md-6 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
																<label style={{ color: '#595959' }} className="fw-500">Address</label>
																{
																	data?.companyBank?.bank_address ? (
																		<input type="text" className="form-control" value={data?.companyBank?.bank_address} disabled />
																	) : (
																		<input type="text" className="form-control" value={'--- N/A ---'} style={{ color: '#707070' }} disabled />
																	)
																}
															</div>
														</>
													) : (
														<div className="col-12 mb-3 contacts-approval-no-data">
															No available bank details
														</div>
													)
												}
											</>
										)
									}
								</div>

								<div className="row" style={{ marginBottom: 20 }}>
									<div className="col-12" style={{ marginBottom: 20 }}>
										<h5 style={{ marginBottom: 0, fontWeight: 600 }}>Interests </h5>
									</div>
									<div className="col-12 mb-3">
										{
											isLoading ? (
												<div className="w-full flex gap-3">
													<div style={{ width: '120px' }}>
														<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
													</div>
													<div style={{ width: '120px' }}>
														<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
													</div>
													<div style={{ width: '120px' }}>
														<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
													</div>
												</div>
											) : (
												data?.interests?.length > 0 ? (
													<div className="popup-small-card-tag-container">
														{
															data?.interests?.map((interest, index) => (
																<div className="popup-small-card-tag-content" >{interest?.name}</div>
															))
														}
													</div>
												) : (
													<div className="col-12 mb-3 contacts-approval-no-data">
														No available interests
													</div>
												)
											)
										}
									</div>
								</div>

								<div className="row" style={{ marginBottom: 20 }}>
									<div className="col-12" style={{ marginBottom: 20 }}>
										<h5 style={{ marginBottom: 0, fontWeight: 600 }}>Specifications </h5>
									</div>
									<div className="col-12 mb-3">
										{
											isLoading ? (
												<div className="w-full flex gap-3">
													<div style={{ width: '120px' }}>
														<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
													</div>
													<div style={{ width: '120px' }}>
														<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
													</div>
													<div style={{ width: '120px' }}>
														<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
													</div>
												</div>
											) : (
												data?.specifications?.length > 0 ? (
													<div className="popup-small-card-tag-container">
														{
															data?.specifications?.map((specification, index) => (
																<div className="popup-small-card-tag-content" >{specification?.name}</div>
															))
														}
													</div>
												) : (
													isLoading ? (
														<div className="col-12 mb-3 contacts-approval-no-data">
															<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
														</div>
													) : (
														<div className="col-12 mb-3 contacts-approval-no-data">
															No available specifications
														</div>
													)
												)
											)
										}
									</div>
								</div>
								{isApproved != 2 && (
									<div className="row" style={{ marginBottom: 20, marginTop: 35 }}>
										<div className="col-12">
											<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
												{
													isLoading ? (
														<>
															<div style={{ width: '110px' }}>
																<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
															</div>
															<div style={{ width: '110px' }}>
																<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
															</div>
														</>
													) : (
														<>
															<button
																className={`btn btn-primary btn-outlined-reject ${isButtonsDisabled ? 'disabled' : ''}`}
																disabled={isButtonsDisabled ? true : false}
																onClick={() => {
																	if (!isButtonsDisabled) {
																		rejectContact(data?.client.id)
																	}
																}}
															>
																{
																	isButtonsDisabled === 'REJECT' ? (
																		<>
																			<FaSpinner className='spinner' style={{ height: '15px', width: '25px', marginRight: '0px' }} /> Processing... 
																		</>
																	) : (
																		<>
																			Reject <RxCrossCircled size={20} />
																		</>
																	)
																}
																
															</button>
															<button
																className={`btn btn-primary btn-outlined-main ${isButtonsDisabled ? 'disabled' : ''}`}
																disabled={isButtonsDisabled ? true : false}
																onClick={() => {
																	if (!isButtonsDisabled) {
																		approveContact(data?.client.id)
																	}
																}}
															>
																{
																	isButtonsDisabled === 'APPROVE' ? (
																		<>
																			<FaSpinner className='spinner' style={{ height: '15px', width: '25px', marginRight: '0px' }} /> Processing... 
																		</>
																	) : (
																		<>
																			Approve <IoIosCheckmarkCircleOutline size={20} />
																		</>
																	)
																}
																
															</button>
														</>
													)
												}
											</div>
										</div>
									</div>
								)}
						</div>
					</div>
				</div>
			</Modal.Body>
		</Modal>
	);
};

export default DetailModal;
